import { FallbackFilterEnum } from "./FallbackEnum";

export const fieldOptions = [
    { label: FallbackFilterEnum.FlowKPI, value: FallbackFilterEnum.FlowKPI },
    { label: FallbackFilterEnum.PressureKPI, value: FallbackFilterEnum.PressureKPI },
    { label: FallbackFilterEnum.CompressorFailure, value: FallbackFilterEnum.CompressorFailure },
];

export const defaultFilterCondition = { id: 1, field: '', value: [] };

export const fallbackConstants = {
    field: "field",
    rules: "rules",
    value: "value",
}